$.fn.initCycle = function (input_options) {

    var options = {
        'slides': '> .js-cycle-slide',
        'swipe': true,
        'speed': 3000,
        'easing': 'easeOutCirc',
        'manualSpeed': 1000,
        'timeout': 5000,
        'next': '.js-cycle-next',
        'prev': '.js-cycle-prev',
        'log': false,
        'fx': 'scrollHorz'
    };

    $.extend(options, input_options);

    this.cycle(options);

};